var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c('div',{staticStyle:{"margin-left":"35%","margin-top":"0.75%"}},[_c('the-progress')],1),_c(_vm.currComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }